import { lazy } from "react";
// Clinical Note AI — análisis de notas con IA (upload de PDF).
const ClinicalNoteAiPage = lazy(() => import("./pages/ClinicalNoteAiPage"));
export const clinicalNoteAiRoutes = [
  { path: '/ClinicalNoteAi', element: <ClinicalNoteAiPage /> },
];

export { ClinicalNoteAiPage };

